import React, { useEffect } from 'react'
import { useFormContext } from 'react-hook-form'

import ApiService from '../../../../../services/ApiService'
import type { FashionOrderFormValues } from '../fashionOrder.schema'

/** Preenche o fornecedor com a empresa matriz na criação. Vive no form porque escreve nele. */
const FashionAutofillBridge: React.FC<{ isEditing: boolean }> = ({ isEditing }) => {
  const { setValue } = useFormContext<FashionOrderFormValues>()

  useEffect(() => {
    if (isEditing) return
    const fetchMatrixCompany = async () => {
      try {
        const response = await ApiService.companies.findAll({ isMain: 'true' })
        const data = Array.isArray(response.data) ? response.data : response.data.data
        if (data && data.length > 0) {
          const matriz = data.find((c: any) => {
            const cnpjClean = c.cnpj?.replace(/\D/g, '') || ''
            return cnpjClean.slice(8, 12) === '0001'
          })
          const source = matriz || data[0]
          setValue('supplier', source.companyName || source.name || '')
          setValue('supplierId', source.id)
          setValue('supplierDetails', {
            companyName: source.companyName || source.name || '',
            cnpj: source.cnpj,
            cpf: source.cpf,
            city: source.city,
            state: source.state,
            contacts: source.contacts,
          })
        }
      } catch (error) {
        console.error('Erro ao buscar empresa matriz:', error)
      }
    }
    fetchMatrixCompany()
  }, [isEditing, setValue])

  return null
}

export default FashionAutofillBridge
